import { useState } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import tailwindConfig from '../../../../../tailwind.config';
import { RegionEnum } from '../../../../core/japaneseRegions';
import { Locale } from '../../../../core/constants';

const Hokkaido = dynamic(() => import('./Hokkaido'));
const Tohoku = dynamic(() => import('./Tohoku'));
const Kanto = dynamic(() => import('./Kanto'));
const Chubu = dynamic(() => import('./Chubu'));
const Chugoku = dynamic(() => import('./Chugoku'));
const Kansai = dynamic(() => import('./Kansai'));
const Shikoku = dynamic(() => import('./Shikoku'));
const Kyushu = dynamic(() => import('./Kyushu'));
const Okinawa = dynamic(() => import('./Okinawa'));

const RECT_HEIGHT = 50;

type Props = {
  selectedArea: number;
  setSelectedArea: (val: number) => void;
  mobile?: boolean;
};

const Map: React.FC<Props> = ({ selectedArea, setSelectedArea, mobile = false }) => {
  const { locale } = useRouter();
  const [hoverArea, setHoverArea] = useState<number | null>(null);
  const defaultTextColor = tailwindConfig.theme.colors.gray[950];
  const defaultAreaColor = tailwindConfig.theme.colors.green[400];
  const selectedAreaColor = tailwindConfig.theme.colors.orange[700];
  const hoverAreaColor = tailwindConfig.theme.colors.green[600];
  const rectWidth = locale === Locale.ENGLISH ? 90 : 83;

  const getColor = (key: keyof typeof RegionEnum, regionCardText?: boolean) => {
    if (RegionEnum[key] === selectedArea) {
      return selectedAreaColor;
    }

    if (regionCardText) return defaultTextColor;

    if (RegionEnum[key] === hoverArea) {
      return hoverAreaColor;
    }

    return defaultAreaColor;
  };

  return (
    <svg
      width="500"
      height={`${mobile ? '300' : '430'}`}
      viewBox="0 0 570 430"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        {/* Each of prefecture svgs has 3 layers and that why there are 3 "path" tags for each of the images.
        The hidden layers can be removed technically but keep them there for the map to appaer as is in wireframe.
        Region name card component wrapped with "g" tags being followed by the prefecture svgs. */}

        <Hokkaido
          getColor={getColor}
          setSelectedArea={setSelectedArea}
          setHoverArea={setHoverArea}
          rectWidth={rectWidth}
          rectHeight={RECT_HEIGHT}
        />
        <Tohoku
          getColor={getColor}
          setSelectedArea={setSelectedArea}
          setHoverArea={setHoverArea}
          rectWidth={rectWidth}
          rectHeight={RECT_HEIGHT}
        />
        <Kanto
          getColor={getColor}
          setSelectedArea={setSelectedArea}
          setHoverArea={setHoverArea}
          rectWidth={rectWidth}
          rectHeight={RECT_HEIGHT}
        />
        <Chubu
          getColor={getColor}
          setSelectedArea={setSelectedArea}
          setHoverArea={setHoverArea}
          rectWidth={rectWidth}
          rectHeight={RECT_HEIGHT}
        />
        <Chugoku
          getColor={getColor}
          setSelectedArea={setSelectedArea}
          setHoverArea={setHoverArea}
          rectWidth={rectWidth}
          rectHeight={RECT_HEIGHT}
        />
        <Kansai
          getColor={getColor}
          setSelectedArea={setSelectedArea}
          setHoverArea={setHoverArea}
          rectWidth={rectWidth}
          rectHeight={RECT_HEIGHT}
        />
        <Shikoku
          getColor={getColor}
          setSelectedArea={setSelectedArea}
          setHoverArea={setHoverArea}
          rectWidth={rectWidth}
          rectHeight={RECT_HEIGHT}
        />
        <Kyushu
          getColor={getColor}
          setSelectedArea={setSelectedArea}
          setHoverArea={setHoverArea}
          rectWidth={rectWidth}
          rectHeight={RECT_HEIGHT}
        />
        <Okinawa
          getColor={getColor}
          setSelectedArea={setSelectedArea}
          setHoverArea={setHoverArea}
          rectWidth={rectWidth}
          rectHeight={RECT_HEIGHT}
        />
      </g>
    </svg>
  );
};

export default Map;
